import React, { useContext, useState } from "react";

import {
  Container,
  Box,
  IconButton,
  Stack,
  Drawer,
  Hidden,
  Typography,
  useTheme,
  styled,
  Button,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";

import { NavLink } from "react-router-dom";
import { AppContext } from "../../utils";
import logo from "../../Components/images/mainlogo.png";
import { Web3Button } from "@web3modal/react";

const StyledLink = styled(NavLink)(() => ({
  textDecoration: "none",
  "&:focus, &:hover, &:visited, &:link, &:active": {
    textDecoration: "none",
    color: "black",
  },
}));

const Header = () => {
  const [state, setState] = useState(false);

  const { account, connect } = useContext(AppContext);

  const theme = useTheme();
  const toggleDrawer = () => {
    setState((prev) => (prev === true ? false : true));
  };

  const data = [
    {
      title: "Home",
      path: "/",
    },

    {
      title: "White paper",
      path: "/whitepaper",
    },

    {
      title: "Dapp",
      path: "/staking",
    },
    {
      title: "Farming",
      path: "/farming",
    },
  ];

  return (
    <Box
      sx={{
        backgroundColor:
          "linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
        boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        py: { md: 2, xs: 1 },
      }}
    >
      <Container>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Box>
            <StyledLink to="/">
              <Box
                component="img"
                src={logo}
                alt=""
                width={{ md: "40%", xs: "40px" }}
              />
            </StyledLink>
          </Box>
          <Hidden mdDown>
            <Box
              display="flex"
              justifyContent="flex-start"
              gap={4}
              width="100%"
            >
              {data.map((item, i) => {
                return (
                  <NavLink
                    to={item?.path}
                    style={{ textDecoration: "none", color: "white" }}
                    key={i}
                  >
                    <Typography
                      key={i}
                      className="rainfall-button"
                      sx={{
                        color: `${theme.palette.text.lightblue}`,
                        fontFamily: "Poppins",
                        fontWeight: "500",
                        fontSize: "18px",
                        cursor: "pointer",
                      }}
                    >
                      {item?.title}
                    </Typography>
                  </NavLink>
                );
              })}
            </Box>
            <Box
              display="flex"
              gap={4}
              justifyContent="end"
              alignItems="center"
              width={{ lg: "80%", md: "20%" }}
            >
              <Web3Button
                icon="show"
                style={{ backgroundColor: "red !important" }}
              />
            </Box>
          </Hidden>
          <Hidden mdUp>
            <Box display="flex" alignItems="center" gap={2}>
              <IconButton onClick={() => toggleDrawer()}>
                <MenuIcon
                  style={{
                    fontSize: "28px",
                  }}
                />
              </IconButton>
            </Box>
            <Drawer anchor="left" open={state} onClose={() => toggleDrawer()}>
              <Box
                sx={{
                  background:
                    "linear-gradient(98.3deg, rgb(0, 0, 0) 10.6%, rgb(255, 0, 0) 97.7%)",
                  width: 250,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 3,
                  px: 2,

                  pt: 4,
                }}
              >
                <Box>
                  <NavLink to="/">
                    <Box
                      component="img"
                      src={logo}
                      alt="img"
                      sx={{ width: "60px" }}
                    />
                  </NavLink>
                </Box>

                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={4}
                >
                  {data.map((item, i) => {
                    return (
                      <NavLink
                        to={item?.path}
                        style={{ textDecoration: "none", color: "white" }}
                        key={i}
                      >
                        <Typography
                          className="rainfall-button"
                          key={i}
                          sx={{
                            color: `${theme.palette.text.lightblue}`,
                            fontFamily: "Poppins",
                            fontWeight: "500",
                            fontSize: "16px",
                            cursor: "pointer",
                          }}
                        >
                          {item?.title}
                        </Typography>
                      </NavLink>
                    );
                  })}
                </Box>

                {account ? (
                  <Button
                    className="rainfall-button"
                    sx={{
                      color: "white",
                      border: "2px solid white",
                      borderRadius: "50px",
                      padding: "0.5rem 1rem",
                      textTransform: "none",
                    }}
                    style={{ zIndex: 1 }}
                  >
                    {account.slice(0, 4) + "..." + account.slice(-4)}
                  </Button>
                ) : (
                  <Button
                    className="rainfall-button"
                    sx={{
                      color: "white",
                      border: "2px solid white",
                      borderRadius: "50px",
                      padding: "0.5rem 1rem",
                      textTransform: "none",
                    }}
                    onClick={() => connect()}
                  >
                    Connect wallet
                  </Button>
                )}
              </Box>
            </Drawer>
          </Hidden>
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
